import type { GanttSingleView } from '../gantt-view-manager.js';
import { MS_PER_DAY, TimeAxisMath } from './time-axis-math.js';

export const DEFAULT_GANTT_ROW_DURATION_DAYS = 3;

/**
 * Gives a row inserted through the Gantt list a complete schedulable range.
 * Existing values win, so filter/default-value integrations can provide a
 * custom start or end without being overwritten.
 */
export function ensureDefaultGanttRowRange(
  view: GanttSingleView,
  rowId: string,
  now = Date.now()
): void {
  const startColumnId = view.startDateCol$.value;
  const endColumnId = view.endDateCol$.value;
  if (!startColumnId || !endColumnId) return;

  const startProperty = view.propertyGetOrCreate(startColumnId);
  const endProperty = view.propertyGetOrCreate(endColumnId);
  const storedStart = startProperty.valueGet(rowId);
  const start =
    typeof storedStart === 'number'
      ? storedStart
      : TimeAxisMath.floorToDayUtc(now);

  if (typeof storedStart !== 'number') {
    startProperty.valueSet(rowId, start);
  }
  if (typeof endProperty.valueGet(rowId) !== 'number') {
    endProperty.valueSet(
      rowId,
      start + DEFAULT_GANTT_ROW_DURATION_DAYS * MS_PER_DAY
    );
  }
}
